module.exports = __webpack_public_path__ + "static/media/canvas-builder.b1b8b901.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/canvas-builder.mov
// module id = 404
// module chunks = 0